import React from "react";

import { graphql } from "relay-runtime";
import { Loader } from "semantic-ui-react";

import { useLazyLoadQuery } from "~/lib/relayUtil";
import EditObjective, { type EditObjectiveProps } from "~/okrs/EditObjective";
import { Modal } from "~/ui/legacyFellowIndex";

import type { EditObjectiveFromIdQuery } from "~/__generated__/EditObjectiveFromIdQuery.graphql";

const objectiveQuery = graphql`
	query EditObjectiveFromIdQuery($id: ID!) {
		objective: node(id: $id) {
			... on Objective {
				id
				title
				hasAccess
				contributors {
					id
					email

					image
					fullName
					isGuest
				}
				contributorsTeams {
					id
					isAccountWideTeam
					members {
						id
						email
					}

					title
				}

				visibility
				dueDate
				assigneeUser {
					id
					email
					image
					fullName
					isGuest
				}
				assigneeTeam {
					id
					title
				}
				description
				status
				archived
				weight
				visibility
				cycle {
					id
				}
				parent {
					id
					title
					level
				}
				progress
				keyResults {
					id
					title
					dueDate
					assigneeUser {
						id
						email
						image
						fullName
						isGuest
					}
					assigneeTeam {
						id
						title
					}
					metricProgress
					metricType
					metricCurrency
					metricStart
					metricCurrent
					metricTarget
					weight
					order
					progress
				}
			}
		}
	}
`;

type EditObjectiveFromIdProps = Omit<EditObjectiveProps, "objective"> & {
	id: string;
};

function EditObjectiveFromId({ id, onClose, ...rest }: EditObjectiveFromIdProps) {
	const data = useLazyLoadQuery<EditObjectiveFromIdQuery>(objectiveQuery, { id }, {});

	if (!data.objective) {
		return (
			<Modal onClose={onClose}>
				<Modal.Header onClose={onClose}>Objective not found</Modal.Header>
				<Modal.Body>
					Sorry, the objective selected was not found. It might have been deleted or you don&apos;t have access to it.
				</Modal.Body>
			</Modal>
		);
	}

	// @ts-ignore
	return <EditObjective objective={data.objective} onClose={onClose} {...rest} />;
}

export default function EditObjectiveFromIdWrapper({ onClose, ...rest }: EditObjectiveFromIdProps) {
	return (
		<React.Suspense fallback={<Loader active />}>
			<EditObjectiveFromId onClose={onClose} {...rest} />
		</React.Suspense>
	);
}
